var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('img',{staticClass:"logo",class:{link: _vm.link},style:(_vm.style),attrs:{"src":_vm.asset(`logo${_vm.white ? '-white' : ''}.png`, 'img') + '?1'},on:{"click":_vm.navigate}})])
}
var staticRenderFns = []

export { render, staticRenderFns }